import { render, staticRenderFns } from "./ButtonWithCheckMark.vue?vue&type=template&id=6d2531be&scoped=true&lang=pug&"
import script from "./ButtonWithCheckMark.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithCheckMark.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonWithCheckMark.vue?vue&type=style&index=0&id=6d2531be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2531be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2531be')) {
      api.createRecord('6d2531be', component.options)
    } else {
      api.reload('6d2531be', component.options)
    }
    module.hot.accept("./ButtonWithCheckMark.vue?vue&type=template&id=6d2531be&scoped=true&lang=pug&", function () {
      api.rerender('6d2531be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ButtonWithCheckMark.vue"
export default component.exports